import Lang from "../../userPreferences/staticWords";
import * as Yup from "yup";
export const formikValidation = (touched, errors, fieldName) => {
  return touched[fieldName] && errors[fieldName] ? errors[fieldName] : false;
};
export const validationSchema = () => {
  return {
    createNewActivity: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().nullable(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      EstimatedTime: Yup.number().nullable(),
      PriorityId: Yup.string().required(Lang.require),
      ActivityStatusId: Yup.string().required(Lang.require),
      AdminActivityMembers: Yup.array(),
      ActivityMembers: Yup.array().nullable(),
      files: Yup.array(),
      ExecutionPercentage: Yup.number().nullable(),
      MilestoneId: Yup.number().required(Lang.require), //for activity
      file: Yup.string(),
    },
    createProjectPopup: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().nullable(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      ProjectStatusId: Yup.string().required(Lang.require),
      PriorityId: Yup.string().required(Lang.require),
      ProjectTypeId: Yup.string().required(Lang.require),
      AdminMembers: Yup.array(),
      Members: Yup.array().nullable(),
      files: Yup.array(),
      file: Yup.string(),
    },
    editProjectPopup: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().nullable(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      ProjectStatusId: Yup.string().required(Lang.require),
      PriorityId: Yup.string().required(Lang.require),
      ProjectTypeId: Yup.string().required(Lang.require),
      AdminMembers: Yup.array(),
      Members: Yup.array().nullable(),
    },
    addMilestone: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
      MilestoneStatusId: Yup.string().required(Lang.require),
    },
    editMilestone: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
      ProjectStatusId: Yup.string().required(Lang.require),
    },
    editPopup: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().nullable(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      EstimatedTime: Yup.number().nullable(),
      PriorityId: Yup.string().required(Lang.require),
      ProjectStatusId: Yup.string().required(Lang.require),
      AdminTaskMembers: Yup.array(),
      TaskMembers: Yup.array().nullable(),
      ExecutionPercentage: Yup.number().nullable(),
    },
  };
};

export const initialValues = (pageData) => {
  return {
    createNewActivity: {
      Name: "",
      Description: "",
      StartDate: new Date().toISOString().substring(0, 10),
      EndDate: "",
      EstimatedTime: 0,
      PriorityId: "",
      ActivityStatusId: 1,
      AdminActivityMembers: [],
      ActivityMembers: [],
      files: [],
      file: "",
      MilestoneId: "",
      ExecutionPercentage: 0,
    },
    createProjectPopup: {
      Name: "",
      Description: "",
      StartDate: new Date().toISOString().substring(0, 10),
      EndDate: "",
      ProjectStatusId: 1,
      PriorityId: "",
      ProjectTypeId: "",
      AdminMembers: [],
      Members: [],
      files: [],
      file: "",
    },
    editProjectPopup: {
      Name: pageData?.nameA ?? "",
      Description: pageData?.descriptionA ?? "",
      StartDate:
        pageData?.startDate ?? new Date().toISOString().substring(0, 10),
      EndDate: pageData?.endDate ?? "",
      ProjectStatusId: pageData?.projectStatusId ?? "",
      PriorityId: pageData?.priorityId ?? "",
      ProjectTypeId: pageData?.projectTypeId ?? "",
      AdminMembers: pageData?.adminmemberIds ?? [],
      Members: pageData?.memberIds ?? [],
    },
    addMilestone: {
      Name: "",
      Description: "",
      MilestoneStatusId: 0,
    },
    editMilestone: {
      Name: pageData?.name ?? "",
      Description: pageData?.description ?? "",
      ProjectStatusId: pageData?.projectStatus?.id,
    },
    editPopup: {
      Name: pageData?.nameA ?? "",
      Description: pageData?.descriptionA ?? "",
      StartDate:
        pageData?.startDate ?? new Date().toISOString().substring(0, 10),
      EndDate: pageData?.endDate ?? "",
      EstimatedTime: pageData?.estimatedTime ?? 0,
      PriorityId: pageData?.priorityId ?? "",
      ProjectStatusId: pageData?.projectStatusId ?? "",
      AdminTaskMembers: pageData?.adminmemberIds ?? [],
      TaskMembers: pageData?.memberIds ?? [],
      ExecutionPercentage: pageData?.executionPercentage ?? 0,
    },
  };
};

export const formikSetup = (
  initialValues,
  sourceOfIntailData,
  validationSchema,
  pageName,
  submitFunction
) => {
  return {
    initialValues: {
      ...initialValues(sourceOfIntailData)[pageName],
    },
    validationSchema: Yup.object({ ...validationSchema(Yup)[pageName] }),
    onSubmit: submitFunction,
  };
};
